import useAsyncState from '../../utils/useAsyncState';

const useAsyncIcon = useAsyncState;

export default useAsyncIcon;
